// base ↔ 表示単位の換算（§4.1）。レート未取得は null を返す（呼び出し側で警告）。
import type { RateTable } from './rate-table';

/** 金額 a（単位 X）→ base: a × rate(X)。 */
export function toBase(amount: number, unit: string, rt: RateTable): number | null {
  const r = rt.rate(unit);
  return r == null ? null : amount * r;
}

/** base → 表示単位 D: value / rate(D)。 */
export function fromBase(valueBase: number, unit: string, rt: RateTable): number | null {
  const r = rt.rate(unit);
  return r == null || r === 0 ? null : valueBase / r;
}

/**
 * 行の「1個あたり base 価値」（§4.2, 新モデル）。
 * - itemId あり（自動相場）: rate(itemId)
 * - itemId なし（手動）: value × rate(unit)
 * 未取得レートは null（黙って0にしない）。
 */
export function rowBaseValue(
  row: { itemId?: string; unit: string; value: number },
  rt: RateTable,
): number | null {
  if (row.itemId) {
    const r = rt.rate(row.itemId);
    return r == null ? null : r;
  }
  const u = rt.rate(row.unit);
  return u == null ? null : row.value * u;
}
